module.exports = __webpack_public_path__ + "img/sendInvitationOR.985b726d.svg";